(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  // Use 'load' instead of 'DOMContentLoaded' so the scroll happens after images
  // have reserved their space — prevents the jump that inflates CLS.
  const url = new URL(window.location.href);
  if (url.hash) {
    window.addEventListener(
      'load',
      () => {
        requestAnimationFrame(() => {
          const card = document.getElementById(url.hash.slice(1));
          if (card) {
            card.scrollIntoView({ behavior: 'instant', block: 'start' });
          }
        });
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
